'use client'; // Error boundaries must be Client Components

import Link from 'next/link';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    // global-error must include html and body tags
    <html>
      <body>
        <div className="px-8 py-8 md:px-20 md:py-20">
          <h2>Something went wrong!</h2>
          <div className="flex items-center gap-3">
            <button className="btn" onClick={reset}>
              Try again
            </button>
            <Link href="/">Go back home</Link>
          </div>
        </div>
      </body>
    </html>
  );
}
